import NavBarMobileArrow from './navbar_arrow.svg';

const NAVBAR_MOBILE = {
  NavBarMobileArrow,
};

export { NAVBAR_MOBILE };
